// extracted by mini-css-extract-plugin
export default {"root":"CreateOrder_root__KqrPJ","main":"CreateOrder_main__uHDXS","backBtn":"CreateOrder_backBtn__4cm-s"};